import { render, staticRenderFns } from "./AnswerCards.vue?vue&type=template&id=566b4a90"
import script from "./AnswerCards.vue?vue&type=script&lang=js"
export * from "./AnswerCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports